import { ValidatedField } from "./ValidatedField";
import { finanzamtByBufa, finanzamtBezeichnung } from "./finanzaemter";
import { PLACEHOLDERS, parseSteuernummer, validateSteuernummer } from "../validation";

/**
 * Steuernummer-Feld: akzeptiert lokale (10–11 Ziffern) oder 13-stellige
 * bundeseinheitliche Nummer. Bei 13 Stellen wird die BUFA (erste 4 Ziffern)
 * aufgelöst — NUR wenn ein Finanzamt dazu existiert — und dessen Name via
 * `onFinanzamtResolved` nach oben gemeldet (→ Finanzamt-Prefill).
 */
export function SteuernummerInput({
  label,
  name,
  value,
  onChange,
  onFinanzamtResolved,
}: {
  label: string;
  name: string;
  value: string;
  onChange: (v: string) => void;
  /** Bezeichnung UND Amtsnummer — die Steuernummer kennt beide exakt. */
  onFinanzamtResolved?: (finanzamtName: string, bufa: string) => void;
}) {
  return (
    <ValidatedField
      label={label}
      name={name}
      value={value}
      onChange={onChange}
      inputMode="numeric"
      placeholder={PLACEHOLDERS.steuernummer}
      sanitize={(v) => v.replace(/[^\d/\s]/g, "")}
      normalizeOnBlur={(v) => v.trim()}
      validate={validateSteuernummer}
      onCommit={(v) => {
        const p = parseSteuernummer(v);
        if (p.kind === "elster13" && p.bufa && onFinanzamtResolved) {
          const fa = finanzamtByBufa(p.bufa);
          // Dieselbe Bezeichnung wie in der Auswahlliste — sonst stünde nach
          // dem Prefill ein Name im Feld, den die Liste nicht kennt.
          if (fa) onFinanzamtResolved(finanzamtBezeichnung(fa), fa.bufa);
        }
      }}
    />
  );
}

export default SteuernummerInput;
